import {
    Col,
    FormGroup,
    Input,
    Label,
    Row
} from "reactstrap";
import { MetaTags } from "react-meta-tags";
import { BreadcrumbShowCountlabel, commonPageFieldSuccess, } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { commonPageField } from "../../../store/actions";
import { useHistory } from "react-router-dom";
import {
    comAddPageFieldFunc,
    formValid,
    initialFiledFunc,
    onChangeSelect,

} from "../../../components/Common/validationFunction";
import Select from "react-select";
import { Go_Button, PageLoadingSpinner, SaveButton } from "../../../components/Common/CommonButton";
import {
    breadcrumbReturnFunc,
    loginCompanyID,
    metaTagLabel
} from "../../../components/Common/CommonFunction";
import * as pageId from "../../../routes//allPageID";
import * as mode from "../../../routes/PageMode";
import React, { useEffect, useState } from "react";
import * as _cfunc from "../../../components/Common/CommonFunction";
import { PartiesOnPartyType_API } from "../../../helpers/backend_helper";
import { getPartyTypelist } from "../../../store/Administrator/PartyTypeRedux/action";
import GlobalCustomTable from "../../../GlobalCustomTable";
import { deleteItemMBQMOQ, getItemMBQMOQ, resetItemMBQMOQState, saveItemMBQMOQ } from "../../../store/Administrator/MbqAndMvqRedux/actions";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import SaveButtonDraggable from "../../../components/Common/saveButtonDraggable";
import DynamicColumnHook from "../../../components/Common/TableCommonFunc";
import { alertMessages } from "../../../components/Common/CommonErrorMsg/alertMsg";
import { listPageActionsButtonFunc } from "../../../components/Common/ListActionsButtons";

const MBQAndMVQ = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();


    const [userPageAccessState, setUserPageAccessState] = useState('');

    const fileds = {
        PartyType: null,
        Party: null
    }

    const [state, setState] = useState(() => initialFiledFunc(fileds))
    const [partyOptions, setPartyOptions] = useState([]);
    const location = { ...history.location }
    const hasShowModal = props.hasOwnProperty(mode.editValue)
    const [tableData, setTableData] = useState([]);
    const [pageMode, setPageMode] = useState(mode.defaultsave);

    const {
        pageField,
        userAccess,
        Data,
        PartyTypes,
        itemList,
        mbqData,
        goBtnLoading,
        saveBtnloading,
        postMsg,
        deleteMsg,
        listBtnLoading
    } = useSelector((state) => ({
        PartyTypes: state.PartyTypeReducer.ListData,
        userAccess: state.Login.RoleAccessUpdateData,
        pageField: state.CommonPageFieldReducer.pageField,
        itemList: state.ItemMastersReducer.ItemList,
        mbqData: state.ItemMBQMOQReducer.tableData,
        listBtnLoading: state.ItemMBQMOQReducer.listBtnLoading,
        goBtnLoading: state.ItemMBQMOQReducer.goBtnLoading,
        saveBtnloading: state.ItemMBQMOQReducer.saveBtnloading,
        postMsg: state.ItemMBQMOQReducer.PostData,
        deleteMsg: state.ItemMBQMOQReducer.deleteData

    }));

    useEffect(() => {

        return () => {

            dispatch(resetItemMBQMOQState());
        };

    }, []);

    useEffect(() => {
        const page_Id = pageId.MBQ_AND_MVQ
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(page_Id))


    }, []);



    useEffect(() => {
        dispatch(getPartyTypelist());
    }, []);

    const PartyTypeDropdown_Options = [
        { value: 0, label: "All" },
        ...PartyTypes.map((item) => ({
            value: item.id,
            label: item.Name
        }))
    ];

    // userAccess useEffect
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;
        if (hasShowModal) {
            locationPath = props.masterPath;
        };
        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })
        if (userAcc) {
            setUserPageAccessState(userAcc)
            breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])



    useEffect(() => {
        if (pageField) {
            const fieldArr = pageField.PageFieldMaster
            comAddPageFieldFunc({ state, setState, fieldArr })
        }
    }, [pageField])


    useEffect(() => {
        //  SUCCESS
        if (postMsg?.Status === true && postMsg?.StatusCode === 200) {
            customAlert({
                Type: 1,
                Status: true,
                Message: postMsg.Message,
            });

            setTableData(prev =>
                prev.map(item => ({
                    ...item,
                    currMOQ: "",
                    currMBQ: ""
                }))
            );
            dispatch(resetItemMBQMOQState());

            setState(prev => ({
                ...prev,
                values: {
                    PartyType: null,
                    Party: null
                }
            }));

            // optional (recommended)
            setPartyOptions([]);
            setTableData([]);
        }
        //  ERROR
        else if (postMsg?.Status === false && postMsg?.StatusCode == 400) {

            customAlert({
                Type: 4,
                Message: postMsg.Message,
            });
        }

    }, [postMsg]);


    useEffect(() => {
        if (deleteMsg?.Status === true && deleteMsg?.StatusCode === 200) {
            customAlert({
                Type: 1,
                Status: true,
                Message: deleteMsg.Message,
            });
            dispatch(resetItemMBQMOQState());
            setState(prev => ({
                ...prev,
                values: { PartyType: null, Party: null }
            }));
        }
        else if (deleteMsg?.StatusCode === 400) {
            customAlert({
                Type: 4,
                Message: deleteMsg.Message,
            });
        }
    }, [deleteMsg]);




    useEffect(() => {
        const fetchParties = async () => {

            const partyTypeValue = state.values.PartyType?.value;

            // stop API if value not present
            if (partyTypeValue === undefined || partyTypeValue === null) {
                setPartyOptions([]);
                return;
            }

            //  PartyType change → clear Party
            setState(prev => ({
                ...prev,
                values: {
                    ...prev.values,
                    Party: null
                }
            }));

            //  If PartyType = All
            if (partyTypeValue === 0) {
                setPartyOptions([{ value: 0, label: "All" }]);
                return;
            }

            const resp = await PartiesOnPartyType_API(partyTypeValue);

            if (resp?.StatusCode === 200) {
                const parties = [
                    { value: 0, label: "All" },
                    ...resp.Data.map(p => ({
                        value: p.id,
                        label: p.Name
                    }))
                ];

                setPartyOptions(parties);
            }
        };

        fetchParties();
    }, [state.values.PartyType]);

    async function deleteBodyfunc(config) {
        const { rowData, btnId } = config;

        try {
            const alertResponse = await customAlert({
                Type: 8,
                Message: `${alertMessages.deleteOrNot} MBQ/MOQ : "${rowData.itemName}"`,
            });

            if (alertResponse) {
                dispatch(deleteItemMBQMOQ({
                    id: rowData.deleteId,
                    party_id: rowData.party_id,
                    partytype_id: rowData.partytype_id,
                    CompanyID: loginCompanyID(),
                    btnId,
                }));
            }
        } catch (error) {
            customAlert({
                Type: 4,
                Message: "Something went wrong while deleting. Please try again.",
            });
        }
    }

    const lastColumn = () => {
        return listPageActionsButtonFunc({
            dispatch,
            history,
            userAccState: userPageAccessState,
            deleteActionFun: deleteItemMBQMOQ,
            deleteBodyfunc,
            deleteName: "itemName",
            ButtonMsgLable: "MBQ/MOQ",
            reducers: { listBtnLoading },
        });
    };


    useEffect(() => {
        if (mbqData?.length > 0) {
            const finalData = mbqData.map(item => ({
                id: item.item_id,
                deleteId: item.id,
                itemName: item.ItemName,
                prevMOQ: item.moq || 0,
                prevMBQ: item.mbq || 0,
                currMOQ: "",
                currMBQ: "",
                partytype_id: values.PartyType?.value,
                party_id: values.Party?.value,
                forceDeleteHide: !item.id,
            }));
            setTableData(finalData);
        } else {
            setTableData([]);
        }
    }, [mbqData]);


    const values = state.values;

    async function goButtonHandler(event) {
        event.preventDefault();

        // validation
        if (!values.PartyType?.value && values.PartyType?.value !== 0) {

            customAlert({
                Type: 4,
                Message: "Please select Party Type",
            });

            return;
        }

        if (formValid(state, setState)) {

            try {

                dispatch(getItemMBQMOQ({
                    partytype_id: values.PartyType?.value,
                    party_id: values.Party?.value,
                    CompanyID: loginCompanyID(),
                    GroupType: 1
                }));

            } catch (err) {

                console.error(err);
            }
        }
    }



    const currMOQColumn = () => ({
        dataField: "currMOQ",
        text: "Current MOQ", // see note below — pull from PageFieldMaster once backend adds it
        formatter: (cell, row) => (
            <div>
                <Input
                    type="number"
                    placeholder="Enter MOQ"
                    min={0}
                    key={`${row.id}-moq`}
                    onChange={(e) => {
                        row.currMOQ = e.target.value;
                        const validationDiv = document.getElementById(`validation-${row.id}`);
                        if (
                            row.currMOQ !== "" &&
                            row.currMBQ !== "" &&
                            Number(row.currMOQ) <= Number(row.currMBQ)
                        ) {
                            validationDiv.innerText = "Please type MOQ greater than MBQ";
                        } else {
                            validationDiv.innerText = "";
                        }
                    }}
                />
                <small id={`validation-${row.id}`} className="text-danger"></small>
            </div>
        )
    });

    const currMBQColumn = () => ({
        dataField: "currMBQ",
        text: "Current MBQ",
        formatter: (cell, row) => (
            <Input
                type="number"
                placeholder="Enter MBQ"
                key={`${row.id}-mbq`}
                onChange={(e) => {
                    row.currMBQ = e.target.value;
                    const validationDiv = document.getElementById(`validation-${row.id}`);
                    if (
                        row.currMOQ !== "" &&
                        row.currMBQ !== "" &&
                        Number(row.currMOQ) <= Number(row.currMBQ)
                    ) {
                        validationDiv.innerText = "Please type MOQ greater than MBQ";
                    } else {
                        validationDiv.innerText = "";
                    }
                }}
            />
        )
    });

    const SaveHandler = async (event) => {
        event.preventDefault();

        try {

            // only user edited rows
            const changedItems = tableData.filter(item => {

                return (
                    item.currMOQ !== "" ||
                    item.currMBQ !== ""
                );
            });

            // EMPTY SAVE
            if (changedItems.length === 0) {
                customAlert({
                    Type: 3,
                    Message: "Please enter MOQ and MBQ",
                });
                return;
            }


            const missingMOQItems = changedItems.filter(
                item =>
                    item.currMOQ === "" &&
                    item.currMBQ !== ""
            );

            if (missingMOQItems.length > 0) {

                const itemNames = missingMOQItems
                    .map(item => item.itemName)
                    .join(", ");

                customAlert({
                    Type: 4,
                    Message: `Please enter MOQ for: ${itemNames}`,
                });

                return;
            }

            const missingMBQItems = changedItems.filter(
                item =>
                    item.currMOQ !== "" &&
                    item.currMBQ === ""
            );

            if (missingMBQItems.length > 0) {

                const itemNames = missingMBQItems
                    .map(item => item.itemName)
                    .join(", ");

                customAlert({
                    Type: 4,
                    Message: `Please enter MBQ for: ${itemNames}`,
                });

                return;
            }

            const invalidItems = changedItems.filter(
                item =>
                    item.currMOQ !== "" &&
                    item.currMBQ !== "" &&
                    Number(item.currMOQ) <= Number(item.currMBQ)
            );

            if (invalidItems.length > 0) {

                const itemNames = invalidItems
                    .map(item => item.itemName)
                    .join(", ");

                customAlert({
                    Type: 4,
                    Message: `MOQ should be greater than MBQ for: ${itemNames}`,
                });

                return;
            }




            const finalPayload = changedItems.map(item => ({
                item_id: item.id,
                partytype_id: values.PartyType?.value,
                party_id: values.Party?.value,

                moq: Number(item.currMOQ || 0),
                mbq: Number(item.currMBQ || 0)
            }));


            console.log("FINAL SAVE:", finalPayload);

            dispatch(saveItemMBQMOQ({
                jsonBody: JSON.stringify(finalPayload)
            }));

        } catch (err) {
            console.error(err);
        }
    };

    const [tableColumns] = DynamicColumnHook({
        pageField,
        userAccState: userPageAccessState,
        thirdLastColumn: currMOQColumn,
        secondLastColumn: currMBQColumn,
        lastColumn
    });


    if (!(userPageAccessState === '')) {
        return (
            <React.Fragment>
                <PageLoadingSpinner isLoading={(!pageField)} />
                <MetaTags>{metaTagLabel(userPageAccessState)}</MetaTags>
                <div className="page-content" >
                    <form noValidate>
                        <div className="px-2   c_card_filter text-black" >
                            <div className="row align-items-center py-2">

                                <Col sm="4" className="ms-2">
                                    <FormGroup className="row mt-2">
                                        <Label className="col-sm-3 p-2">Party Type</Label>
                                        <Col sm="7">
                                            <Select
                                                name="PartyType"
                                                value={state.values.PartyType}
                                                options={PartyTypeDropdown_Options}
                                                className="react-dropdown"
                                                classNamePrefix="dropdown"
                                                onChange={(hasSelect, evn) =>
                                                    onChangeSelect({ hasSelect, evn, state, setState })
                                                }
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col>

                                <Col sm="4">
                                    <FormGroup className="row mt-2">
                                        <Label className="col-sm-2 p-2">Party</Label>
                                        <Col sm="7">
                                            <Select
                                                name="Party"
                                                value={state.values.Party}
                                                options={partyOptions}
                                                isSearchable
                                                className="react-dropdown"
                                                classNamePrefix="dropdown"
                                                onChange={(hasSelect, evn) =>
                                                    onChangeSelect({ hasSelect, evn, state, setState })
                                                }
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col>

                                {/*  KEY CHANGE */}
                                <Col sm="auto" className="mt-2 ms-auto text-end " style={{ marginRight: "80px" }}>
                                    <Go_Button
                                        loading={goBtnLoading}
                                        onClick={goButtonHandler}
                                    />
                                </Col>

                            </div>
                        </div>

                        <div className="">

                            <GlobalCustomTable
                                keyField="id"
                                data={tableData}
                                columns={tableColumns}
                                paginationEnabled
                                id="mbq_table"
                                noDataIndication={
                                    <div className="text-danger text-center">
                                        Record Not Available
                                    </div>
                                }
                                classes={"custom-table"}
                                onDataSizeChange={({ dataCount }) => {
                                    dispatch(BreadcrumbShowCountlabel(`Count:${dataCount}`));
                                }}
                            />
                        </div>


                        {tableData.length > 0 && (
                            <SaveButtonDraggable>
                                <SaveButton
                                    onClick={SaveHandler}
                                    loading={saveBtnloading}
                                    userAcc={userPageAccessState}
                                    pageMode={pageMode}
                                />

                            </SaveButtonDraggable>
                        )}
                    </form>

                </div>
            </React.Fragment >
        );
    }
    else {
        return (
            <React.Fragment></React.Fragment>
        )
    }
};

export default MBQAndMVQ

